export const getBuildId = () => {
  try {
    const buildId = window?.BUILD_INFO?.buildId;
    return typeof buildId === 'string' ? buildId : '';
  } catch {
    return '';
  }
};

export const getBuildClient = () => {
  try {
    const buildClient = window?.BUILD_INFO?.buildClient;
    return typeof buildClient === 'string' ? buildClient : 'coachapp';
  } catch {
    return 'coachapp';
  }
};

export const isBrpClient = () => {
  return getBuildClient() === 'brp';
};

export const getCustomerSlugFromUrl = () => {
  try {
    if (typeof window === 'undefined' || !window.location?.hostname) {
      return null;
    }

    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const firstPart = parts[0];

    // Reserved words that should not be considered as client slugs
    const reservedWords = ['stage', 'coach', 'localhost'];

    // If the first part is a reserved word, there's no client slug
    if (reservedWords.includes(firstPart)) {
      return null;
    }

    // For localhost cases (e.g., clientnew.localhost:3000)
    if (hostname.endsWith('.localhost')) {
      return firstPart || null;
    }

    // For production/staging cases (e.g., gymmore.coach.brpsystems.com, gymmore.stage.coach.brpsystems.com)
    // If we have more than the base domain parts and first part is not reserved, it's a client slug
    if (parts.length > 2) {
      return firstPart;
    }

    // If we only have 2 parts or less, no client slug
    return null;
  } catch {
    return null;
  }
};

export const getUrlWithoutCustomerSlug = () => {
  try {
    if (typeof window === 'undefined' || !window.location?.hostname) {
      return null;
    }

    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    // Handle localhost: gymmore.localhost -> http://localhost:3000
    if (hostname.endsWith('.localhost')) {
      return `http://${parts.slice(1).join('.')}:3000`;
    }

    // Handle staging environment
    if (parts.length >= 4 && parts[1] === 'stage' && parts[2] === 'coach' && parts[3] === 'brpsystems') {
      // If URL is like: gymmore.stage.coach.brpsystems.com -> https://stage.coach.brpsystems.com
      return `https://${parts.slice(1).join('.')}`;
    }

    // Handle staging without client slug (already correct format)
    if (parts.length === 4 && parts[0] === 'stage' && parts[1] === 'coach' && parts[2] === 'brpsystems') {
      // If URL is already like: stage.coach.brpsystems.com -> return as is
      return `https://${hostname}`;
    }

    // Handle production environment
    if (parts.length >= 3 && parts[1] === 'coach' && parts[2] === 'brpsystems') {
      // If URL is like: gymmore.coach.brpsystems.com -> https://coach.brpsystems.com
      return `https://${parts.slice(1).join('.')}`;
    }

    // Handle production without client slug (already correct format)
    if (parts.length === 3 && parts[0] === 'coach' && parts[1] === 'brpsystems') {
      // If URL is already like: coach.brpsystems.com -> return as is
      return `https://${hostname}`;
    }

    return null;
  } catch {
    return null;
  }
}

export const shouldRedirectFromInvalidSlug = () => {
  try {
    if (!isBrpClient()) {
      return false;
    }

    const customerSlug = getCustomerSlugFromUrl();
    const currentUrl = window.location.href;
    const urlWithoutSlug = getUrlWithoutCustomerSlug();

    // If there's no customer slug in the URL, no need to redirect
    if (!customerSlug) {
      return false;
    }

    // If we have a customer slug but would redirect to the same URL, don't redirect
    if (urlWithoutSlug && currentUrl.startsWith(urlWithoutSlug)) {
      return false;
    }

    // Only redirect if there's a customer slug that's invalid
    return Boolean(customerSlug && urlWithoutSlug);
  } catch {
    return false;
  }
}